import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge can't read the CSS-first `@theme`/`@utility` defs, so register custom scales
// here — otherwise a custom-vs-default conflict (e.g. shadow-button vs shadow-md) survives
// unmerged. `w-*`/`font-*` already dedupe by prefix. The `type-*` typography shorthands are
// standalone `@utility` defs (not a scale), so they get their own mutually-exclusive group.
export const twMerge = extendTailwindMerge<"type">({
  extend: {
    theme: {
      shadow: [
        "button",
        "secondary-button",
        "bottom-sheet",
        "active-button-shadow",
        "task-header",
        "r-0",
        "l-0",
        "modal-md",
      ],
      text: ["xxs"],
    },
    classGroups: {
      type: [
        {
          type: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "base",
            "base-emphasis",
            "base-strong",
            "base-italic",
            "base-message",
            "base-message-emphasis",
            "sm",
            "sm-emphasis",
            "sm-strong",
            "sm-italic",
            "sm-message",
            "sm-message-emphasis",
            "xs",
            "xs-emphasis",
            "xs-strong",
            "xs-italic",
            "xs-message",
            "xs-message-emphasis",
            "xxs",
            "xxs-emphasis",
            "xxs-strong",
            "xxs-italic",
          ],
        },
      ],
    },
  },
});
